import { CanvasRoutes } from '@/configs/routes/types';

export const BonfireRoutes = {
  [CanvasRoutes.Bonfire]: {
    name: 'Bonfire',
    path: '/bonfire',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.BonfireSolutions]: {
    name: 'Solutions',
    path: '/bonfire/solutions',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.BonfireSolutionCreate]: {
    name: 'Create Solution',
    path: '/bonfire/solutions/create',
    showInNavigation: false,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.BonfireSolutionDetail]: {
    name: 'Solution Detail',
    path: '/bonfire/solutions/:solutionId',
    showInNavigation: false,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.BonfireSolutionStatusChange]: {
    name: 'Solution Status',
    path: '/bonfire/solutions/:solutionId/status',
    showInNavigation: false,
    showInBreadcrumbs: false,
  },
  [CanvasRoutes.BonfireExecutions]: {
    name: 'Executions',
    path: '/bonfire/executions',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.BonfireExecutionRun]: {
    name: 'Run Execution',
    path: '/bonfire/executions/run',
    showInNavigation: false,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.BonfireExecutionDetail]: {
    name: 'Execution Detail',
    path: '/bonfire/executions/:runId',
    showInNavigation: false,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.BonfireModelData]: {
    name: 'Model Data',
    path: '/bonfire/model-data',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.BonfireModelDataForecastQuery]: {
    name: 'Forecast Query',
    path: '/bonfire/model-data/:runId/forecast',
    showInNavigation: false,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.BonfireModelDataEvaluationQuery]: {
    name: 'Evaluation Query',
    path: '/bonfire/model-data/:runId/evaluation',
    showInNavigation: false,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.BonfireForecastExplorer]: {
    name: 'Forecast Explorer',
    path: '/bonfire/forecast-explorer',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.BonfireLeaderboard]: {
    name: 'Leaderboard',
    path: '/bonfire/leaderboard',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
};
